/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/* global FormData */
define([
	'../../../visualizations/vipr/VIPRBundleHelper',
	'../../../widgets/livewidget/nls/StringResources',
	'../../../lib/@waca/core-client/js/core-client/ui/ProgressToast'
], function(
	VIPRBundleHelper,
	StringResources,
	ProgressToast
) {

	const _logError = (dashboardApi, error) => {
		const logger = dashboardApi.getGlassCoreSvc('.Logger');
		logger.error(error);
	};

	const _getErrorDescription = (error) => {
		const message = JSON.parse(error.message);
		return message && message.Description ? message.Description : '';
	};

	return class CustomUtil {

		static deleteCustomVis (dashboardApi, visId, refeshCustomVisCallback) {
			try {
				let definition = dashboardApi.getFeature('VisDefinitions').getById(visId);
				if (!definition) {
					throw new Error('Cannot update bundle: ' + visId);
				}
				let assetId = definition.getProperty('assetId');
				return VIPRBundleHelper.deleteCustomBundleVisulization({ id: visId, assetId: assetId, dashboardApi: dashboardApi })
					.then(refeshCustomVisCallback)
					.then(items => {
						dashboardApi.showToast(StringResources.get('extVisDeleteConfirmation'), { type: 'success' });
						return items;
					}).catch(error => {
						dashboardApi.showToast(StringResources.get('extVisDeleteError', { msg: _getErrorDescription(error) }) , { type: 'error' });
						_logError(dashboardApi, error);
					});
			} catch (error) {
				_logError(dashboardApi, error);
			}
		}

		static addCustomVis (fileEvent, dashboardApi, refreshCustomVisDefinitions) {
			if (fileEvent.target.files.length === 0) return refreshCustomVisDefinitions();
			if (!(window.File && window.FileReader && window.FileList && window.Blob)) {
				console.log('The File APIs are not fully supported in this browser.');
				return refreshCustomVisDefinitions();
			}
			const toast = CustomUtil.getProgressToast(fileEvent.target.files[0].name);
			const data = CustomUtil.getDataFromFileEvent(fileEvent);

			return VIPRBundleHelper.loadCustomBundleVisualization({ data:data, dashboardApi: dashboardApi })
				.then(() => {
					return refreshCustomVisDefinitions(/*refreshAll*/false)
						.then(items => {
							toast.setComplete(100, {
								duration: 0,
								completeMsg: StringResources.get('extVisAdd'),
								isComplete: true
							});
							toast.remove();
							return items;
						});
				}).catch(error => {
					toast.fail(StringResources.get('extVisAddError' , { msg: _getErrorDescription(error) }));
					_logError(dashboardApi, error);
				});
		}

		static updateCustomVis (fileEvent, dashboardApi, refreshCustomVisDefinitions, item = {}) {
			if (fileEvent.target.files.length === 0) return refreshCustomVisDefinitions();
			if (!(window.File && window.FileReader && window.FileList && window.Blob)) {
				console.log('The File APIs are not fully supported in this browser.');
				return refreshCustomVisDefinitions();
			}
			const toast = CustomUtil.getProgressToast(item.label);

			try {
				const definition = dashboardApi.getFeature('VisDefinitions').getById(item.name);
				if (!definition) {
					throw new Error('Cannot update bundle: ' + item.name);
				}
				const bundleId = definition.getId();
				const data = CustomUtil.getDataFromFileEvent(fileEvent);
				return VIPRBundleHelper.updateCustomBundleVisualization({ data:data, dashboardApi: dashboardApi, bundleId: bundleId, assetId: definition.getProperty('assetId') })
					.then(() => {
						return refreshCustomVisDefinitions(/*refreshAll*/false)
							.then(items => {
								toast.setComplete(100, {
									duration: 0,
									completeMsg: StringResources.get('extVisUpdate'),
									isComplete: true
								});
								void(items);
								toast.remove();
								return items;
							});
					}).catch ((error) => {
						toast.fail(StringResources.get('extVisUpdateError' , { msg: _getErrorDescription(error) }));
						_logError(dashboardApi, error);
					});

			} catch (error) {
				_logError(dashboardApi, error);
			}
		}


		static getDataFromFileEvent(fileEvent) {
			const file = fileEvent.target.files[0];
			const formData = new FormData();
			formData.append(file.name, file);
			return formData;
		}

		static getProgressToast(name) {
			const toast = new ProgressToast({
				noCancelBtn: true
			});
			const addProgressString = StringResources.get('extVisUpdateProgress', { 'name': name });
			toast.show(addProgressString);
			toast.indefinite(addProgressString);
			return toast;
		}
	};
});
